import { InjectionToken } from '@angular/core';

export interface MessagingConfig {
  baseUrl: string;
}

export const MESSAGING_CONFIG = new InjectionToken<MessagingConfig>('MESSAGING_CONFIG');
